import {AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT, AUTH_LOGIN, AUTH_REGISTER} from '../actions/Auth'
import get from 'lodash/get';
import {RepositoryFactory} from "@/app/shared/services/factory/RepositoryFactory";

const repo = RepositoryFactory.get('auth');

const state = {
    token: localStorage.getItem('access_token') || '',
    status: '',
    user: null
};

const getters = {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
    userData: state => state.user
};

const actions = {
    [AUTH_REGISTER]: ({commit}, data) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_REQUEST);
            repo.register(data)
                .then(resp => {
                    localStorage.setItem('access_token', get(resp, 'data.data.access_token'));
                    commit(AUTH_SUCCESS, resp);
                    resolve(resp)
                })
                .catch(err => {
                    commit(AUTH_ERROR, err);
                    localStorage.removeItem('access_token');
                    reject(err)
                })
        })
    },
    [AUTH_LOGIN]: ({commit}, data) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_REQUEST);
            repo.login(data)
                .then(resp => {
                    localStorage.setItem('access_token', get(resp, 'data.data.access_token'));
                    commit(AUTH_SUCCESS, resp);
                    resolve(resp)
                })
                .catch(err => {
                    commit(AUTH_ERROR, err);
                    localStorage.removeItem('access_token');
                    reject(err)
                })
        })
    },
    [AUTH_REQUEST]: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_REQUEST);
            repo.userData()
                .then(resp => {
                    commit(AUTH_SUCCESS, resp);
                    resolve(resp)
                })
                .catch(err => {
                    commit(AUTH_ERROR, err);
                    localStorage.removeItem('access_token');
                    reject(err)
                })
        })
    },
    [AUTH_LOGOUT]: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_LOGOUT);
            localStorage.removeItem('access_token');
            resolve()
        })
    }
};

const mutations = {
    [AUTH_REQUEST]: (state) => {
        state.status = 'loading';
    },
    [AUTH_SUCCESS]: (state, resp) => {
        state.status = 'success';
        state.token = get(resp, 'data.data.access_token');
        state.user = get(resp, 'data.data');
    },
    [AUTH_ERROR]: (state) => {
        state.status = 'error';
    },
    [AUTH_LOGOUT]: (state) => {
        state.token = ''
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
}
